import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

gsap.config({
  // nullTargetWarn: false
})

export let initAnimations, Banner 

initAnimations = () => { 
	Banner()
}

Banner = () => {
	const banner = document.querySelector('.page-header')

	if (!banner || window.isLivePreview) return 

	const header = document.querySelector('.header-wrapper')
	const heading = banner.querySelectorAll('.line')
	const video = document.querySelector('.large-image__image')

	const tl = gsap.timeline({
		delay: window.initialLoad ? 0.8 : 0,
		onComplete: () => {
			header.classList.add('ready')
		}
	})

	tl.fromTo(video, {
		scale: 1.2,
		opacity: 0,
		filter: 'blur(6px)',
	}, {
		scale: 1,
		opacity: 1,
		filter: 'blur(0px)',
		duration: 1.8,
		ease: 'power2.out',
	})

	tl.fromTo(heading, {
		yPercent: 108
	}, {
		yPercent: 0,
		duration: 1.8,
		stagger: 0.1,
		ease: 'expo',
	}, '<')

	if (window.initialLoad) {
		tl.fromTo(header, {
			y: -200,
			opacity: 0
		}, {
			y: 0,
			opacity: 1,
			duration: 1.4,
			ease: 'expo.out',
			clearProps: 'all'
		}, '-=1.6')
	}
}

export default () => { }